import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'
import { Tooltip } from 'react-tippy'
import get from 'lodash/get'
import MilestoneItem from './MilestoneItem'
import LegendEntry from './LegendEntry'
import { capitalize } from '../../../../../../utils/string'
import DragScroll from '../../../../../../components/ui/DragScroll/DragScroll'
import * as userWithSkills from '../../../../../../assets/wheel_icons/withSkills.svg'
import * as userWithoutSkills from '../../../../../../assets/wheel_icons/withoutSkills.svg'
import * as diploma from '../../../../../../assets/wheel_icons/diploma.svg'
import * as briefcase from '../../../../../../assets/wheel_icons/briefcase.svg'

class ListViewPath extends Component {
  static propTypes = {
    careerPaths: PropTypes.any.isRequired,
    isMobile: PropTypes.bool.isRequired,
  }

  constructor() {
    super()

    this.state = {
      data: [],
      pageCount: 0,
      legend: true,
    }

    this.handlePageClick = pageData => {
      const page = pageData.selected
      const { careerPaths } = this.props
      const data = careerPaths && careerPaths.slice(20 * page, 20 * (page + 1))

      this.setState({ data })
    }

    this.skillsHtml = skills => {
      const { isMobile } = this.props
      return (
        <div>
          <h6
            style={{
              color: '#ddd',
              marginBottom: 2,
              textAlign: 'center',
              ...(isMobile ? { fontSize: 10 } : { fontSize: 12 }),
            }}
          >
            Skills
          </h6>
          <h5
            style={{
              color: 'white',
              textAlign: 'center',
              margin: 0,
              ...(isMobile ? { fontSize: 12 } : { fontSize: 14 }),
            }}
          >
            {skills &&
              skills.map((skill, index) =>
                index === skills.length - 1 ? `${capitalize(skill)}` : `${capitalize(skill)}, `,
              )}
          </h5>
        </div>
      )
    }

    this.renderPersonImage = (src, style) => {
      return (
        <div
          className="shadow"
          style={{
            display: 'inline-block',
            width: 90,
            margin: '0 auto 15px',
            borderRadius: '50%',
            padding: 14,
            border: '1px solid #ecf0fc',
            backgroundColor: 'white',
            marginLeft: 10,
            textAlign: 'center',
            ...style,
          }}
        >
          <img src={src} style={{ paddingBottom: 5, width: 51 }} alt="" />
        </div>
      )
    }
  }

  componentWillMount() {
    const { careerPaths } = this.props
    const data = careerPaths && careerPaths.slice(0, 20)
    const pageCount = Math.ceil(careerPaths.length / 20)

    this.setState({
      data,
      pageCount,
    })
  }

  render() {
    const { isMobile } = this.props
    const { data, pageCount, legend } = this.state
    return (
      <div>
        <div>
          <div>
            {legend && (
              <div className="text-center">
                <div style={{ display: 'inline-block', margin: 10, marginBottom: 30 }}>
                  <label style={{ display: 'block', textAlign: 'left' }}>Legend</label>
                  <div
                    style={{
                      padding: '5px 10px',
                      borderRadius: 3,
                      display: 'flex',
                      border: '1px solid #c0c0c5',
                      flexWrap: 'wrap',
                      justifyContent: 'center',
                    }}
                  >
                    <LegendEntry
                      toolTip="Click on this user to see their skills"
                      title="User with Skills"
                      image={userWithSkills}
                    />
                    <LegendEntry
                      toolTip="Click here to see the university and degree name"
                      title="Education Milestone"
                      image={diploma}
                    />
                    <LegendEntry
                      toolTip="Click here to see the job title, company, and salary."
                      title="Career Milestone"
                      image={briefcase}
                    />
                    <LegendEntry
                      toolTip="Results matching your search will display with a dot in the corner."
                      title="Matching Result"
                      is_target={1}
                    />
                    <i
                      className="fal fa-times p-1"
                      onClick={() => this.setState({ legend: false })}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              </div>
            )}

            <div
              className="card-body table-striped"
              style={{ maxHeight: 600, overflowY: 'scroll', paddingTop: 0 }}
            >
              {data &&
                data.map((careerPath, index) => (
                  <div key={index} className="div-stripe" style={{ paddingTop: 10 }}>
                    <DragScroll
                      style={{
                        display: 'block',
                        overflowX: 'auto',
                        whiteSpace: 'nowrap',
                        overflowY: 'hidden',
                      }}
                    >
                      {/*person*/}

                      {careerPath.meta.skills && careerPath.meta.skills.length > 0 ? (
                        <Tooltip
                          html={this.skillsHtml(get(careerPath, 'meta.skills', []).slice(0, 5))}
                          sticky
                          arrow
                          position="top-end"
                          trigger="mouseenter focus"
                        >
                          {this.renderPersonImage(userWithSkills, { cursor: 'pointer' })}
                        </Tooltip>
                      ) : (
                        this.renderPersonImage(userWithoutSkills)
                      )}

                      {careerPath.meta.milestones &&
                        careerPath.meta.milestones.map(
                          (milestone, i) =>
                            get(milestone, 'milestone_title') && (
                              <MilestoneItem key={i} milestone={milestone} isMobile={isMobile} />
                            ),
                        )}
                    </DragScroll>
                  </div>
                ))}
            </div>
            <div className="mt-3 mb-3">
              <ReactPaginate
                previousLabel="Previous"
                nextLabel="Next"
                breakLabel={isMobile ? '' : '...'}
                pageCount={pageCount}
                marginPagesDisplayed={isMobile ? 0 : 2}
                pageRangeDisplayed={isMobile ? 0 : 2}
                onPageChange={this.handlePageClick}
                containerClassName="custom-pagination justify-content-center"
                pageClassName="custom-page-item"
                pageLinkClassName="custom-page-link"
                previousClassName="custom-page-item"
                previousLinkClassName="custom-page-link"
                nextClassName="custom-page-item"
                nextLinkClassName="custom-page-link"
                activeClassName="active-page"
                breakClassName="custom-page-link"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ListViewPath



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/Pathways/ListViewPath.js